import React from 'react'
import ReactDOM from 'react-dom'

import ContainerProduct from '../Containers/ContainerProduct'

const product = document.getElementsByClassName('product')
for(let i = 0; i < product.length; i++){
	const dataProduct = JSON.parse(product[i].getAttribute('data-product'))
	ReactDOM.render(<ContainerProduct {...dataProduct}/>,product[i])
}


// WEBPACK FOOTER //
// ./src/build/product.js